import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import {
  debounceTime,
  distinctUntilChanged,
  finalize,
  merge,
  Observable,
  of,
  Subscription,
  switchMap,
} from 'rxjs';
import { MainTableFilterModulesEnum } from 'src/app/core/enums/main-table-filter-modules.enum';
import { ApiResponse } from 'src/app/core/models/api-response';
import { OrderStatus } from 'src/app/order-user/enums/order-status.enum';
import { IOrderResponse } from 'src/app/order-user/models/order.model';
import { OrderApiService } from 'src/app/order-user/services/order-api.service';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';

@Component({
  selector: 'app-cart-draft-picker-modal',
  templateUrl: './cart-draft-picker-modal.component.html',
  styleUrls: ['./cart-draft-picker-modal.component.scss'],
  standalone: false,
})
export class CartDraftPickerModalComponent implements OnInit, OnDestroy {
  readonly searchControl = new FormControl<string>('');

  draftOrders: IOrderResponse[] = [];
  loading = false;

  private readonly draftPageSize = 10000;
  private readonly subscriptions = new Subscription();

  constructor(
    private dialogRef: MatDialogRef<CartDraftPickerModalComponent>,
    private orderApiService: OrderApiService
  ) {}

  ngOnInit(): void {
    const initialSearch$ = of(this.searchControl.value ?? '');
    const searchChanges$ = this.searchControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    );

    this.subscriptions.add(
      merge(initialSearch$, searchChanges$)
        .pipe(switchMap(() => this.loadDraftOrders()))
        .subscribe((response) => {
          this.draftOrders = response.data;
        })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  selectDraft(order: IOrderResponse): void {
    this.dialogRef.close(order);
  }

  private loadDraftOrders(): Observable<ApiResponse<IOrderResponse[]>> {
    this.loading = true;
    return this.orderApiService
      .getOrders(OrderStatus.Draft, this.getFilter(), false)
      .pipe(finalize(() => (this.loading = false)));
  }

  private getFilter(): MainTableFilterModel {
    const filter = new MainTableFilterModel(MainTableFilterModulesEnum.Orders);
    filter.pageIndex = 0;
    filter.pageSize = this.draftPageSize;
    filter.searchTerm = this.searchControl.value ?? '';

    return filter;
  }
}
